import { WithTooltip } from "./with_tooltip";

export function ErrorTooltip(props: { info: JSX.Element | string }) {
	return (
		<WithTooltip tooltip={<span>{props.info}</span>} style="Error">
			<i className="fas fa-exclamation-circle error-text"></i>
		</WithTooltip>
	);
}
